// Hide .price--large on PDP when Bold Subscriptions widget is present
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.bsub-widget')) {
    document.body.classList.add('c-has-bsub');
  }
});
